import store from '../store/Store';
import type RequestState from '../store/schema/RequestState';
import { type UserActionType } from '../store/schema/UserAction';
import {
    bookwithmePleaseTryAgainSubtext,
    bookwithmeAccountNotAllowedTitle,
    bookwithmeNotYetImplementedTitle,
} from '../components/Shared.locstring.json';
import type { ResourceId } from 'owa-localize';

export default function () {
    const { userActionState, userActionType } = store.userAction;

    const successTitle: ResourceId = '';
    let errorTitle: ResourceId = '';
    const successSubtext: ResourceId = '';
    const errorSubtext = bookwithmePleaseTryAgainSubtext;
    const errorLearnMoreText: ResourceId = '';
    switch (userActionType) {
        case 17:
            errorTitle = bookwithmeAccountNotAllowedTitle;
            break;
        case 18:
            errorTitle = bookwithmeNotYetImplementedTitle; // temporary text that will be removed soon
            break;
        default:
            break;
    }

    let title: ResourceId = '';
    let subText: ResourceId = '';
    let learnMoreText: ResourceId = '';
    switch (userActionState) {
        case 2:
            title = successTitle;
            subText = successSubtext;
            break;
        case 3:
            title = errorTitle;
            subText = errorSubtext;
            learnMoreText = errorLearnMoreText;
            break;
        default:
            break;
    }

    return { title, subText, learnMoreText };
}
